import { InputProps, FormItemProps } from "antd";
import { InputStyle } from "components/ui-component/Input/Input.style";

interface Inputprops extends InputProps {
  onChange?: (
    e: React.ChangeEvent<HTMLInputElement & HTMLTextAreaElement>
  ) => void;
}
type Props = Inputprops & FormItemProps;
const InputField = (props: Props) => {
  const {
    placeholder,
    type,
    size,
    prefix,
    suffix,
    status,
    disabled,
    onChange,
    value,
    maxLength,
    defaultValue,
    addonBefore,
  } = props;

  return (
    <InputStyle
      placeholder={placeholder}
      type={type}
      size={size}
      prefix={prefix}
      suffix={suffix}
      status={status}
      disabled={disabled}
      onChange={onChange}
      value={value}
      maxLength={maxLength}
      defaultValue={defaultValue}
      addonBefore={addonBefore}
    />
  );
};
export default InputField;
